const BotonesOpciones = ({
	animar,
}) => {
	return (
		<div className={`row divGenerador ${animar && "animar"}`}>
			<div className='columns small-12 callout'>
				<div className='columns small-4'>Puedes:</div>
				<div className='columns small-8'>Ver Listado de Clientes:</div>
				&nbsp;
				<div className='columns small-12'>
					<div className='columns small-4'>
						<a
							className='success button large disabled'
						>
							Agregar Cliente Nuevo
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							Vigentes
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							No Vigentes
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							Con Deuda
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							Sin Deuda
						</a>
					</div>
					<div className='columns small-4'>&nbsp;</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							Con Patente
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							Sin Patente
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							Con DICOM
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button large disabled'
						>
							Sin DICOM
						</a>
					</div>
					<div className='columns small-4'>&nbsp;</div>
					<div className='columns small-4'>
						<a
							className='button large disabled'
						>
							Contrato Actualizado
						</a>
					</div>
					<div className='columns small-4'>
						<a
							className='button large disabled'
						>
							Contrato No Actualizado
						</a>
					</div>
				</div>
			</div>
			&nbsp;
			<div className='columns small-12 callout'>
				<div className='columns small-12'>También Puedes:</div>
				&nbsp;
				<div className='columns small-12'>
					<a
						className='warning button large expanded disabled'
					>
						Realizar Busqueda de Clientes
					</a>
				</div>
			</div>
			&nbsp;
			<div className='columns small-12 callout'>
				<div className='columns small-12'>Opciones Antiguas:</div>
				&nbsp;
				<div className='columns small-12'>
					<div className='columns small-3'>
						<a
							className='button alert large disabled'
						>
							Pantalla Antigua
						</a>
					</div>
					&nbsp;
					<div className='columns small-4'>
						<a
							className='button alert large disabled'
						>
							Mostrar Todos los Clientes
						</a>
					</div>
					<div className='columns small-4'>&nbsp;</div>
				</div>
			</div>
		</div>
	);
};

export default BotonesOpciones;
